import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';
import { deleteUserCertification } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const DeleteUserCertificationForm = () => {
  const profileState = useProfileState();
  const { onResponse, onError, closeDeleteUserCertificationModal } = useProfileActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    deleteUserCertification({
      onResponse,
      onError,
      body: {
        authenticityToken,
        deleteUserCertificationForm: profileState?.deleteUserCertificationForm,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormInstruction>
        Are you sure you want to delete this certification?
      </FormInstruction>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              if (profileState?.user?.isAuthenticatedUser) {
                closeDeleteUserCertificationModal();
              }
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="destructive"
          >
            Yes. Delete This Certification.
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default DeleteUserCertificationForm;
